import type { AppProps } from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import { PulseToGtmSync } from 'shared/pulse';
import { Hotjar } from 'shared/util/hotjar';

import { UnleashProvider } from '@/hooks/unleash';

import 'uno.css';

declare global {
    interface Window {
        TrackJS?: {
            install: (data: { token: string; application: string; version: string; enabled: boolean }) => void;
        };
    }
}

const HotelApp = ({ pageProps, Component }: AppProps) => (
    <>
        <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="FINN.no" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:locale" content="no_NO" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@FINN_no" />
            <Hotjar enabled={Boolean(pageProps?.unleash?.hotjar) && pageProps?.hasLegalBasis} />
        </Head>
        <UnleashProvider toggles={pageProps?.unleash}>
            <Component {...pageProps} />
        </UnleashProvider>
        <Script
            src="https://cdn.trackjs.com/agent/v3/latest/t.js"
            onLoad={() => {
                window.TrackJS?.install?.({
                    token: '74bb3e28a1604fd2b28c72c568722d21',
                    application: 'finn-travel-hotel',
                    version: `'${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}'`,
                    enabled: location.host.indexOf('local') !== 0 && location.host.indexOf('127.0.0') !== 0,
                });
            }}
            crossOrigin=""
        />
        <PulseToGtmSync />
    </>
);

export default HotelApp;
